import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { API_HANDLERS } from 'api/apiHandlers';
import { requestForToken } from 'api/firebase';

interface UseActivateTokenReturn {
  isLoading: boolean;
  refetch: () => void;
}

export function useActivateToken(): UseActivateTokenReturn {
  const [token, setToken] = useState<string>();

  useEffect(() => {
    const requestPermissionAfterSWReady = async () => {
      if (!('serviceWorker' in navigator)) {
        return;
      }

      // Wait for the service worker to be ready
      await navigator.serviceWorker.ready;

      // Now request notification permission after a delay
      setTimeout(async () => {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          const token = await requestForToken();
          if (token) {
            setToken(token);
            localStorage.setItem('webPushToken1', token as string);
          } else {
            localStorage.removeItem('webPushToken1');
          }
          // Here you can proceed to request the FCM token
        } else {
          console.log('Notification permission denied.');
          localStorage.removeItem('webPushToken1');
        }
      }, 3000);
    };

    requestPermissionAfterSWReady().catch(console.error);
  }, []);

  const { isLoading, refetch } = useQuery(
    ['activateToken'],
    () => API_HANDLERS.WEBPUSH.SUBSCRIBE({ token: token as string }),
    {
      enabled: !!token,
    },
  );

  return {
    isLoading,
    refetch,
  };
}
